<template>
    <div>

        <div class="container section">
            <div class="row ">
                <div class="col-4">
                    <h2>Location Info</h2>
                </div>
            </div>
            <div class="row ">
                <div class="col">
                    <form @submit.prevent="check">
                        <div class="input-group">
                            <input type="text" v-model="address" class="form-control" />&nbsp;
                            <button class="btn btn-primary">Search</button>

                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="container section text-center" v-show="loading">
            <pulse-loader v-show="loading" color="#5e9cd3"></pulse-loader>
        </div>
        <div class="container section" v-show="found">
            <div class="row lined">
                <div class="col-6 col-sm-3 col-md-2">NPANXX:</div>
                <div class="col-6 col-sm-9 col-md-10">{{addressInfo["NPANXX:"]}}</div>
            </div>

            <div class="row lined">
                <div class="col-6 col-sm-3 col-md-2">Provider:</div>
                <div class="col-6 col-sm-9 col-md-10">{{addressInfo["Provider:"]}}</div>
            </div>

            <div class="row lined">
                <div class="col-6 col-sm-3 col-md-2">Provider Type:</div>
                <div class="col-6 col-sm-9 col-md-10">{{addressInfo["Provider Type:"]}}</div>
            </div>

            <div class="row lined">
                <div class="col-6 col-sm-3 col-md-2">Provider OCN:</div>
                <div class="col-6 col-sm-9 col-md-10">{{addressInfo["Provider OCN:"]}}</div>
            </div>

            <div class="row lined">
                <div class="col-6 col-sm-3 col-md-2">Switch CLLI:</div>
                <div class="col-6 col-sm-9 col-md-10">{{addressInfo["Switch CLLI:"]}}</div>
            </div>
            <div class="row lined">
                <div class="col-6 col-sm-3 col-md-2">State:</div>
                <div class="col-6 col-sm-9 col-md-10">{{addressInfo["State:"]}}</div>
            </div>
            <div class="row lined">
                <div class="col-6 col-sm-3 col-md-2">Rate Center:</div>
                <div class="col-6 col-sm-9 col-md-10">{{addressInfo["Rate Center:"]}}</div>
            </div>
            <div class="row ">
                <div class="col-6 col-sm-3 col-md-2">Lata:</div>
                <div class="col-6 col-sm-9 col-md-10">{{addressInfo["Lata:"]}}</div>
            </div>





        </div>
    </div>

</template>
<script type="text/babel">
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    export default{
        data(){
            return {
                address:'',
                addressInfo: {
                    "NPANXX:": '',
                    "Provider:": '',
                    "Provider Type:": '',
                    "Provider OCN:": '',
                    "Switch CLLI:": '',
                    "State:": '',
                    "Rate Center:": '',
                    "Lata:": ''
                },
                found: false,
                loading: false


            }
        },
        components:{
            PulseLoader
        },
        methods:{
            check(){
                this.loading = true;
                this.found = false;
                this.$send(this, 'addressInfo', { address: this.address}).then(r => {
                    this.found = true;
                    this.loading = false;
                    this.addressInfo = r.addressInfo;
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// LocationInfo.vue?21ad23c4